export function downloadCsv(filename: string, headers: string[], rows: string[][]) {
  const cell = (value: string) => `"${value.replaceAll('"', '""')}"`;
  const body = [headers, ...rows].map((row) => row.map((value) => cell(value ?? "")).join(",")).join("\n");
  const blob = new Blob([`\uFEFF${body}`], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
